/*
 * @Author: Liux
 * @Date: 2019-12-02 03:09:56
 * @LastEditor: Liux
 * @LastEditTime: 2020-08-13 00:45:40
 */
import {
  Component,
  OnInit,
  OnDestroy,
  ViewEncapsulation,
  Injector,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  ElementRef,
  Inject,
  EventEmitter,
  forwardRef,
  Optional,
  InjectionToken,
  Renderer2,
  NgZone,
  ChangeDetectorRef,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {
  Overlay,
  OverlayConfig,
  OverlayRef,
  ConnectionPositionPair,
} from '@angular/cdk/overlay';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';
import { AdDateRangePopupComponent } from './popup/ad-date-range-popup.component';
import { AdDateRangeEventService } from './services/ad-date-range-event.service';
import { AdDateRangeModel } from './common/ad-date-range-model';
import { CONFIG_DATA } from './common/ad-date-range-inject-key';
import { Subscription } from 'rxjs';
import {
  format,
  parse,
  isValid,
  setMilliseconds,
  setSeconds,
  setMinutes,
  setHours,
} from 'date-fns';
import { BodyOverflowHiddenScrollStrategy } from '../ad-common/body-overflow-hidden-scroll-strategy';
export const DateRange_Fommat_CONFIG = new InjectionToken<{ format: string }>(
  'data-range-format-config'
);
@Component({
  selector: 'ad-date-range',
  templateUrl: './ad-date-range.component.html',
  styleUrls: ['./ad-date-range.component.scss'],
  providers: [
    AdDateRangeEventService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AdDateRangeComponent),
      multi: true,
    },
  ],
  encapsulation: ViewEncapsulation.None,
})
export class AdDateRangeComponent
  implements OnInit, OnDestroy, ControlValueAccessor {
  //#region NgModel
  _rangeDates: AdDateRangeModel;

  set rangeDates(value: AdDateRangeModel) {
    if (this.withOutHMS) {
      value.startDate = value.startDate
        ? setMilliseconds(
          setSeconds(setMinutes(setHours(value.startDate, 0), 0), 0),
          0
        )
        : value.startDate;
      value.endDate = value.endDate
        ? setMilliseconds(
          setSeconds(setMinutes(setHours(value.endDate, 0), 0), 0),
          0
        )
        : value.endDate;
    }
    this.valueOnChange(value);
    this._rangeDates = value;
  }

  // _setRangeDates(value: AdDateRangeModel) {
  //   if (this.withOutHMS) {
  //     value.startDate = value.startDate
  //       ? setMilliseconds(
  //         setSeconds(setMinutes(setHours(value.startDate, 0), 0), 0),
  //         0
  //       )
  //       : value.startDate;
  //     value.endDate = value.endDate
  //       ? setMilliseconds(
  //         setSeconds(setMinutes(setHours(value.endDate, 0), 0), 0),
  //         0
  //       )
  //       : value.endDate;
  //   }
  //   this.valueOnChange(value);
  //   this._rangeDates = value;
  // }

  get rangeDates() {
    return this._rangeDates;
  }
  valueOnChange = (v: AdDateRangeModel) => { };
  valueOnTouch = () => { };

  writeValue(obj: AdDateRangeModel): void {
    this._rangeDates = obj;
    this.eventService.rangeValueChangeByOutside.emit(obj);
    this.onDateRangeChangeByOutside.emit(obj);
  }
  registerOnChange(fn: any): void {
    this.valueOnChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.valueOnTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void { }
  //#endregion
  constructor(
    private overlay: Overlay,
    private eventService: AdDateRangeEventService,
    private injector: Injector,
    private renderer2: Renderer2,
    private ngZone: NgZone,
    private cd: ChangeDetectorRef,
    @Inject(DOCUMENT) private _document: any,
    @Optional() @Inject(DateRange_Fommat_CONFIG) private formatConfig: any
  ) {
    if (formatConfig) {
      this.format = formatConfig.format;
    }
  }

  @Input() headerToolTemplate: TemplateRef<any>;
  @Input() footerToolTemplate: TemplateRef<any>;
  @Output() onBeforeClose: EventEmitter<any> = new EventEmitter<any>(false);
  @Output() onClosed: EventEmitter<any> = new EventEmitter<any>();
  @Output() onBeforeOpen: EventEmitter<any> = new EventEmitter<any>(false);
  @Output() onToolClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() onOpened: EventEmitter<any> = new EventEmitter<any>();
  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDayClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDateRangeClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDateRangeChangeByOutside: EventEmitter<any> = new EventEmitter<any>();
  @Input() format = 'yyyy/M/d';
  @Input() withOutHMS = true; // set the date object's hours/minutes/seconds/millseconds to 0.
  /**
   * If set to true, will auto close the calendar after the user finished the range selecting
   * or the user click anywhere except this component.
   */
  @Input() autoClosePopup = true;

  /**
   * if set to true, will auto emit the AdDateRangeEventService's rangeValueChange event
   * after the user completed they range selecting.
   * if set to false, will need the user to manual calls the AdDateRangePopupComponent's apply
   * and close functions to apply the range(emit the rangeValueChange event) or close the popup
   */
  @Input() autoApplyDateRange = true;
  @Input() startFormatFun: any;
  @Input() endFormatFun: any;

  get startDate() {
    if (this.rangeDates) {
      return this.formatDate(this.rangeDates.startDate);
    } else {
      return '';
    }
  }

  set startDate(val: string) {
    const result = parse(val, this.format, new Date());
    if (isValid(result)) {
      this.rangeDates.startDate = result;
    }
  }

  get endDate() {
    if (this.rangeDates) {
      return this.formatDate(this.rangeDates.endDate);
    } else {
      return '';
    }
  }

  set endDate(val: string) {
    const result = parse(val, this.format, new Date());
    if (isValid(result)) {
      this.rangeDates.endDate = result;
    }
  }

  @ViewChild('text', { read: ElementRef, static: true })
  textComponent: ElementRef;
  popupOverlayRef: OverlayRef;
  dayClickSubscription: Subscription;
  eventRemoverList: any[] = [];
  popupEventRemover: any;
  addEventRemover(fun: any) {
    if (fun) {
      this.eventRemoverList.push(fun);
    }
  }

  runEventRemoverList() {
    this.eventRemoverList.forEach((r) => {
      if (r) {
        r();
      }
    });
  }

  createInjector(dataToPass): PortalInjector {
    const injectorTokens = new WeakMap();
    injectorTokens.set(CONFIG_DATA, dataToPass);
    return new PortalInjector(this.injector, injectorTokens);
  }
  ngOnInit() {
    this.eventService.rangeValueChange.subscribe((event) => {
      this.rangeDates = event;
      this.onChange.emit({ target: this, value: this.rangeDates });
      if (this.autoClosePopup) {
        this.closePopup(null);
      }
    });
    this.eventService.updatePosition.subscribe(event => {
      if (this.popupOverlayRef) {
        this.popupOverlayRef.updatePosition();
      }
    })
    this.eventService.toolClick.subscribe((clickEvent) => {
      this.onToolClick.emit(clickEvent);
    });
    this.eventService.close.subscribe((event) => {
      this.closePopup(event);
    });
    this.eventService.dateClick.subscribe((event) =>
      this.onDayClicked.emit(event)
    );
    this.eventService.dateRangeClick.subscribe((event) =>
      this.onDateRangeClick.emit(event)
    );
    if (this.autoClosePopup) {
      this.ngZone.runOutsideAngular(() => {
        this.addEventRemover(
          this.renderer2.listen(document, 'mousedown', (e: Event) => {
            if (
              this.popupOverlayRef !== undefined &&
              this.popupOverlayRef !== null
            ) {
              if (
                !(this.popupOverlayRef.overlayElement as any).contains(
                  e.target
                ) &&
                !this.textComponent.nativeElement.contains(e.target)
              ) {
                this.closePopup(null);
                this.cd.detectChanges();
              }
            }
          })
        );
      });
      // document.addEventListener('mousedown', );
    }
    this.ngZone.runOutsideAngular(() => {
      this.addEventRemover(
        this.renderer2.listen(
          this.textComponent.nativeElement,
          'click',
          this.stopBubble
        )
      );
    });
    // this.textComponent.nativeElement.addEventListener('click', this.stopBubble);
  }

  formatDate(date: Date) {
    if (date) {
      return format(date, this.format);
    }
    return '';
  }

  stopBubble(event) {
    event.stopPropagation();
    return false;
  }
  private getPositions(): ConnectionPositionPair[] {
    return [
      {
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top',
        offsetY: 10,
      },
      {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top',
        offsetY: 10,
      },
      {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'bottom',
        offsetY: -10,
      },
      {
        originX: 'end',
        originY: 'top',
        overlayX: 'end',
        overlayY: 'bottom',
        offsetY: -10,
      },
    ];
  }
  openPopup(event: Event) {
    if (this.popupOverlayRef == null) {
      const openEvent = new CustomEvent('dateRangeBeforeOpen', {
        cancelable: true,
      });
      this.onBeforeOpen.emit(openEvent);
      if (openEvent.defaultPrevented === false) {
        const position = this.overlay
          .position()
          .flexibleConnectedTo(this.textComponent)
          .withPositions(this.getPositions())
          .withTransformOriginOn('center top')
          .withViewportMargin(10)
          .withDefaultOffsetY(30);
        const config = new OverlayConfig({ positionStrategy: position, scrollStrategy: new BodyOverflowHiddenScrollStrategy() });
        this.popupOverlayRef = this.overlay.create(config);
        this.popupOverlayRef.overlayElement.classList.add(
          'dr-popup-overlay-container'
        );
        this.ngZone.runOutsideAngular(() => {
          this.popupEventRemover = this.renderer2.listen(
            this.popupOverlayRef.overlayElement,
            'click',
            this.stopBubble
          );
        });

        const filePreviewPortal = new ComponentPortal(
          AdDateRangePopupComponent,
          null,
          this.createInjector({
            headerToolTemplate: this.headerToolTemplate,
            footerToolTemplate: this.footerToolTemplate,
            rangeValue: this.rangeDates,
            format: this.format,
            autoApplyDateRange: this.autoApplyDateRange,
            component: this,
          })
        );
        this.popupOverlayRef.attach(filePreviewPortal);
        this.dayClickSubscription = this.eventService.dateClick.subscribe(
          () => { }
        );
        event.cancelBubble = true;
        event.stopPropagation();
        this.onOpened.emit({
          overlayRef: this.popupOverlayRef,
          component: this,
        });
      }
    }
  }

  ngOnDestroy(): void {
    this.eventService.close.unsubscribe();
    this.eventService.dateClick.unsubscribe();
    this.eventService.rangeValueChange.unsubscribe();
    this.eventService.toolClick.unsubscribe();
    this.eventService.dateRangeClick.unsubscribe();
    this.eventService.updatePosition.unsubscribe();
    // this.textComponent.nativeElement.removeEventListener(
    //   'click',
    //   this.stopBubble
    // );
    if (this.dayClickSubscription) {
      this.dayClickSubscription.unsubscribe();
    }
    if (this.popupOverlayRef) {
      this.popupOverlayRef.dispose();
    }
    this.runEventRemoverList();
  }

  closePopup(event = null, isEmitEvent: boolean = true) {
    if (isEmitEvent) {
      const closeEvent = new CustomEvent('dateRangeBeforeClose', {
        cancelable: true,
      });
      this.onBeforeClose.emit(closeEvent);
    }
    if (!isEmitEvent || !event || !event.defaultPrevented) {
      if (this.popupOverlayRef) {
        if (this.popupEventRemover) {
          this.popupEventRemover();
        }
        this.popupOverlayRef.dispose();
      }
      this.popupOverlayRef = null;
      this.onOpened.emit({ component: this });
    }
  }
}
